
export const UtilsText = {
    'EmpresaDiaReq': 'Empresa en un dia - El rut ingresado ya posee una transacción asociada',
    'EmpresaDiaReq1': 'Empresa en un dia - El rut ingresado ya posee una transaccion en proceso',
    'textEmpresaDiaResp': `El rut consultado ya posee una transacción el día de hoy.
     Utilice Buscar para revisar el informe.`
};

export function goToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

export function downloadExcelFromBase64(base64String: string, fileName = 'reporte.xlsx'): void {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length)

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    
    const byteArray = new Uint8Array(byteNumbers)
    
    const blob = new Blob([byteArray], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName;
    link.click()
    
    URL.revokeObjectURL(url)
}